import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "tw-inline-block" }
const _hoisted_3 = {
  key: 1,
  class: "tw-block tw-p-[10px] tw-border tw-border-solid tw-border-primary tw-opacity-50"
}
const _hoisted_4 = {
  key: 2,
  class: "tw-absolute tw-top-[-12px] tw-right-[-19px]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResultMark = _resolveComponent("ResultMark")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spellings, (op, key) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        class: "tw-relative tw-inline-block tw-top-0 tw-left-0 tw-m-[10px]"
      }, [
        (_ctx.results[key] === undefined)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "",
              onClick: _withModifiers(($event: any) => (_ctx.selectOption(key)), ["prevent"]),
              class: "tw-block tw-p-[10px] tw-border tw-border-solid tw-border-primary tw-no-undeline hover:tw-bg-primaryvlt"
            }, [
              _createElementVNode("span", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(op, (s, skey) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: skey,
                    class: _normalizeClass(["tw-inline-block tw-p-[5px]", 'act-dl-cl-' + (skey + 1)])
                  }, _toDisplayString(s.value), 3))
                }), 128))
              ])
            ], 8, _hoisted_1))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(op, (s, skey) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: skey,
                    class: _normalizeClass(["tw-inline-block tw-p-[5px]", 'act-dl-cl-' + (skey + 1)])
                  }, _toDisplayString(s.value), 3))
                }), 128))
              ])
            ])),
        (_ctx.results[key] !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_ResultMark, {
                result: _ctx.results[key] > 0
              }, null, 8, ["result"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}